define('paychex.app.messages/icon/module',[
    'angular',
    './MessagesIconController',
    'paychex.app.common/services',
    'paychex.app.common/globalFrameUI/module',
    'paychex.app.messages/services/module', // MessageListModelService
    'paychex.framework.angular.localization/module', // TranslationService
    'paychex.framework.angular.eventing/module'      // EventingService
],
    function (
        angular,
        MessagesIconController,
        CommonServices,
        GlobalFrameUIModule,
        MessageServicesModule,
        pngLocalizationModule,
        pngEventingModule
    ) {

        'use strict';

        /**
         * @namespace paychex.app.messages.messagesIcon
         * @description Provides MessagesIconController Angular component.
         */
        return angular.module('paychex.app.messages.messagesIcon', [
            'ng',
            MessageServicesModule.name,
            CommonServices.name,
            GlobalFrameUIModule.name,
            pngEventingModule.name,
            pngLocalizationModule.name
        ])
            .controller('MessagesIconController', MessagesIconController);

    });

